import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import { DateFormaterMonth } from "../../Components/GlobalFunctions";
import { ContentLoader } from "../../Components/Shimmer";
import "./PreviewStatus.css"

const PreviewStatus = () => {
    const { apiURL, apiHeaderJson } = useContext(ConfigContext);
    const { project_request_id } = useParams();
    const [selectOption, setSelectOption] = useState(null);
    const [loadingList, setLoadingList] = useState(false);
    const [consultantInfo, setConsultantInfo] = useState([]);
    const [attachments, setAttachments] = useState([])
    const [requestedInfo, setRequestedInfo] = useState({});
    const navigate = useNavigate()
    const [errors, setErrors] = useState({})
    const naviagte = useNavigate()

    const options = [
        { value: "0", label: "Pending" },
        { value: "1", label: "Approved" },
        { value: "2", label: "Revise" },
        { value: "3", label: "Rejected" },
        { value: "4", label: "In-Clearance" },
    ];

    const Labels = (status) => {
        if (status === 0) {
            return "Pending";
        } else if (status === 1) {
            return "Approved";
        } else if (status === 2) {
            return "Revise";
        }
        else if (status === 3) {
            return "Rejected";
        }
        else if (status === 4) {
            return "In-Clearence";
        }
    };

    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning";
        } else if (status === 1) {
            return "badge bg-success-subtle text-success";
        } else if (status === 2) {
            return "badge bg-info-subtle text-info";
        } else if (status === 3) {
            return "badge bg-danger-subtle text-danger";
        } else if (status === 4) {
            return "badge bg-secondary-subtle text-secondary";
        }
    };

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : "");
    };


    const GetInfo = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/requests/GetProjectRequestInfo?project_request_id=${project_request_id}`, {
                headers,
            })
            const { data, success } = response.data;
            if (success) {
                setRequestedInfo(data.info)
                setConsultantInfo(data.consultants)
                setAttachments(data.attachments)
                setLoadingList(false)
            }
        } catch (error) {
            console.log(error);

        } finally {
            setLoadingList(false)
        }
    };

    useEffect(() => {
        project_request_id && GetInfo()
    }, [project_request_id]);


    return (
        <>
            {
                loadingList ? <ContentLoader /> :
                    <>
                        <div className="center-form-wrapper">
                            <div className="">
                                {/* start page title */}
                                <div className="row">

                                </div>
                                {/* end page title */}
                                <div className="vi-container shadow-none border">
                                    <div className="vi-preview shadow-none printable-area">
                                        <div className="row justify-content-center">
                                            <div className="col-xxl-9">
                                                <div className="card" id="demo">
                                                    <div className="row">

                                                        <div className="col-lg-12">
                                                            <div className="card-body ">
                                                                <div className="vi-participant-section">
                                                                    <div className="vi-logo">
                                                                        <img
                                                                            src="/assets/images/new_logo.png"
                                                                            alt="Company Logo"
                                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                                        />
                                                                    </div>

                                                                    <div className='vi-participant'>
                                                                        <p style={{ marginBlock: "0px" }}>{requestedInfo?.project_title}</p>
                                                                        <h6 style={{ color: "lightgray" }}>Project</h6>
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <div className="row mb-1" >
                                                                                    <div className="col-6"><p style={{ marginBlock: "0px" }}>{DateFormaterMonth(requestedInfo?.project_start_date)}</p></div>
                                                                                    <div className="col-6"><p style={{ marginBlock: "0px" }}>{DateFormaterMonth(requestedInfo?.project_end_date)}</p></div>
                                                                                    <div className="col-6" style={{ color: "lightgray" }}>Start Date</div>
                                                                                    <div className="col-6" style={{ color: "lightgray" }}>End Date</div>
                                                                                </div>
                                                                                <div className="row mb-1" >
                                                                                    <div className="col-12"><p style={{ marginBlock: "0px" }}>{requestedInfo?.project_address}</p></div>
                                                                                    <div className="col-12" style={{ color: "lightgray" }}>Location </div>

                                                                                </div>

                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                    <div className="vi-participant " style={{ marginLeft: '100px' }}>
                                                                        <p style={{ marginBlock: "0px" }}>{requestedInfo?.profile_name}</p>
                                                                        <h6 style={{ color: "lightgray" }}>Contractor</h6>
                                                                        <p style={{ marginBlock: "0px" }}> {DateFormaterMonth(requestedInfo?.request_date)}</p>
                                                                        <h6 style={{ color: "lightgray" }}>Request Date</h6>
                                                                    </div>
                                                                </div>
                                                                <div className="header">

                                                                    <div className="row mb-1 mt-2" >
                                                                        <div className="col-md-2 mx-4" style={{ fontSize: "fw-bolder" }}>Ref. # : {(requestedInfo?.project_request_id)}</div>
                                                                        <div className="col-md-2">Rev # : {(requestedInfo?.request_revision_count)}</div>
                                                                    </div>
                                                                </div>


                                                                {/*end row*/}
                                                            </div>
                                                            {/*end card-body*/}
                                                        </div>

                                                        {/*end col*/}
                                                        <div className="col-lg-12">
                                                            <div className="card-body p-4 pt-0">
                                                                <div className="table-responsive">
                                                                    <table className="table table-borderless text-center table-nowrap align-middle mb-0">
                                                                        <thead>
                                                                            <tr className="table-active">
                                                                                <th scope="col" style={{ width: 50 }}>
                                                                                    {`Sr.No`}
                                                                                </th>
                                                                                <th scope="col">{'Item Name'}</th>
                                                                                <th scope="col">{'Quantity'}</th>
                                                                                <th scope="col">{'Price'}</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody id="products-list">

                                                                            <tr >
                                                                                <th scope="row">1</th>
                                                                                <th scope="row">  {requestedInfo?.item_name}</th>
                                                                                <th scope="row">  {requestedInfo?.pi_item_qty}</th>
                                                                                <th scope="row">{requestedInfo?.pi_item_price}</th>
                                                                            </tr>

                                                                        </tbody>
                                                                    </table>
                                                                    {/*end table*/}
                                                                </div>

                                                                <div className="row mb-3 mt-4">
                                                                    <div className="col-md-6">
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Type Of Submittal'}
                                                                        </p>
                                                                        <h5 className="fs-14 mb-0">
                                                                            {requestedInfo?.submittal_description}
                                                                        </h5>
                                                                    </div>

                                                                </div>

                                                                <div className="row mb-3">
                                                                    <div className="col-md-6">
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Consultant Revision'}
                                                                        </p>
                                                                        <h5 className="fs-14 mb-3" style={{ textAlign: "justify" }}>
                                                                            {requestedInfo?.request_revision_remark ?? "-"}

                                                                        </h5>
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Breif Description'}
                                                                        </p>
                                                                        <h5 className="fs-14 mb-3" style={{ textAlign: "justify" }}>
                                                                            {requestedInfo?.request_brief_description}
                                                                        </h5>
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Status'}
                                                                        </p>
                                                                        <span className={Classes(requestedInfo?.request_status)}>
                                                                            {Labels(requestedInfo?.request_status)}
                                                                        </span>


                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <label className="text-muted mb-2 text-uppercase fw-semibold">Digital Sign</label>
                                                                        <div className="signature-container">
                                                                            <img
                                                                                className="signature-image"
                                                                                src={`${apiURL}api/profile-signature/${requestedInfo.digital_signature}`}
                                                                                alt="Signature"
                                                                                onError={(e) => {
                                                                                    e.target.style.display = 'none';
                                                                                    e.target.parentElement.innerHTML = '<p class="text-muted mb-0">No Signature Available</p>';
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="row  mb-3">
                                                                    <div className="col-md-6">
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Submitted By (Name):'}
                                                                        </p>
                                                                        <h5 className="fs-14 mb-0">
                                                                            {requestedInfo?.profile_name}
                                                                        </h5>
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <p className="text-muted mb-2 text-uppercase fw-semibold">
                                                                            {'Position'}
                                                                        </p>
                                                                        <h5 className="fs-14 mb-0">
                                                                            {requestedInfo?.profile_about ?? "-"}
                                                                        </h5>
                                                                    </div>
                                                                </div>

                                                                <div className="row mb-3">
                                                                    <div className="col-md-12">

                                                                    </div>
                                                                </div>
                                                                <div className="vi-actions no-print mt-4 ">
                                                                    <button
                                                                        className="btn btn-success float-end"
                                                                        onClick={() => window.print()}
                                                                    >
                                                                        Print <i className="ri-printer-line ms-2" />
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-info float-end me-2 mb-4"
                                                                        onClick={() => navigate(-1)}
                                                                    >
                                                                        Go Back <i className="ri-arrow-go-back-line ms-2" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {/*end card-body*/}
                                                        </div>
                                                        {/*end col*/}
                                                    </div>
                                                    {/*end row*/}
                                                </div>

                                                {/*end card*/}
                                            </div>
                                            {/*end col*/}
                                        </div>

                                        {/*end row*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }


        </>
    );
};

export default PreviewStatus;